import script from "./eSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./eSwitch.vue?vue&type=script&setup=true&lang=js"

import "./eSwitch.vue?vue&type=style&index=0&id=2758e3a6&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2758e3a6"]])

export default __exports__